import React, { FC, HTMLAttributes } from 'react';
import styled from '@emotion/styled';

import { Body } from '../../typography';

export const StyledModalTitle = styled.div();

export const ModalTitle: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return (
    <StyledModalTitle {...props}>
      <Body type="base" weight="medium" textAlign="center">
        {children}
      </Body>
    </StyledModalTitle>
  );
};
